import { ModalProps } from 'antd/lib/modal';

import { useTranslation } from 'react-i18next';
import { ModalCustom } from '../ModalCustom';
import { translateCodes } from '../../../locales';
import { HeaderModalDelete } from './HeaderModalDelete';

interface ModalDeleteProps extends ModalProps { }

export const ModalDelete = (props: ModalDeleteProps) => {
    const { t } = useTranslation();
    return (
        <ModalCustom
            open={props?.open}
            title={<HeaderModalDelete />}
            onCancel={props.onCancel}
            onOk={props.onOk}
            okButtonProps={{
                className: 'btn-delete',
            }}
            okText={t(translateCodes.DELETE)}
            cancelText={t(translateCodes.CANCEL)}
            showDivider={false}
            footer={props.footer}
            confirmLoading={props.confirmLoading}
        >
            <div className='line-container'>
                <div className='line one' />
                <div className='line two' />
                <div className='line three' />
                <div className='line four' />
            </div>
            <div className='content'>
                {props?.children}
            </div>
        </ModalCustom>
    );
};
